import './loader.css';

interface ILoaderProps {
  isLoading?: boolean;
  transparent?: boolean;
  relative?: boolean;
}

const Loader = ({ isLoading, transparent = true, relative = false }: ILoaderProps) =>
  isLoading ? (
    <div className={` 'loader-overlay' ${transparent ? 'transparent' : 'opaque'} ${relative ? 'relative' : ''}`}>
      <span className="loader"></span>
    </div>
  ) : null;

export default Loader;
